/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiLoggerSetting.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-logger-setting";

export class AutogenModelEdiLoggerSetting<RowType extends ModelRow> extends Endpoint<RowType, RowEdiLoggerSettingFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiLoggerSetting extends ModelRow<RowEdiLoggerSettingFields> {
	constructor(values?: Partial<RowEdiLoggerSettingFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiLoggerSettingFields {
	company_id: string;
	last_update_date: Date;
	log_level: number;
	log_level_default: number;
	log_name: string;
	revert_days: number;
	weeks_to_keep: number;
	weeks_to_keep_default: number;
}

